var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-wang-editor", class: { "is-readonly": _vm.isReadonly } },
    [
      _vm.showToolbar && !_vm.isReadonly
        ? _c(
            "div",
            {
              staticClass: "bj-wang-editor__toolbar",
              on: {
                mousedown: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "bj-wang-editor__upload-button",
                  attrs: { type: "button", title: "Upload Image" },
                  on: { click: _vm.triggerImageSelect },
                },
                [_c("i", { staticClass: "el-icon-picture-outline" })]
              ),
              _c("input", {
                ref: "imageInput",
                staticClass: "bj-wang-editor__upload-input",
                attrs: { type: "file", accept: "image/*" },
                on: { change: _vm.handleImageChange },
              }),
            ]
          )
        : _vm._e(),
      _c("Editor", {
        staticClass: "bj-wang-editor__editor",
        style: _vm.editorStyle,
        attrs: { "default-config": _vm.editorConfig, mode: _vm.mode },
        on: {
          onCreated: _vm.handleCreated,
          onChange: _vm.handleChange,
          onBlur: _vm.handleBlur,
          customPaste: _vm.handlePaste,
        },
        model: {
          value: _vm.html,
          callback: function ($$v) {
            _vm.html = $$v
          },
          expression: "html",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }